(() => {
  const script = document.currentScript;
  const selector = 'bullseye-upload';
  const cssURL = script?.dataset.headingsCss;
  if (!cssURL || !('adoptedStyleSheets' in ShadowRoot.prototype)) return;
  const sheet = new CSSStyleSheet();
  const ready = fetch(cssURL).then(response => {
    if (!response.ok) throw new Error('Heading styles unavailable');
    return response.text();
  }).then(css => sheet.replace(css));
  async function apply(element) {
    try {
      await Promise.all([ready, customElements.whenDefined(element.localName)]);
      const root = element.shadowRoot;
      if (root && !root.adoptedStyleSheets.includes(sheet)) root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    } catch { }
  }
  function scan(node) {
    if (!(node instanceof Element)) return;
    if (node.matches(selector)) apply(node);
    node.querySelectorAll(selector).forEach(apply);
  }
  scan(document.documentElement);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) scan(node);
  }).observe(document.body, {childList: true, subtree: true});
})();
